<template>
  <div class="passwordetail">
    <navBack title="学习记录"></navBack>
    <div class="passwordetail_title">
      <p>学习记录</p>
    </div>
    <div class="" style="padding: 20px">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="课程名称" align="center" />
        <el-table-column
          prop="lastStudyTime"
          label="最后学习时间"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.lastStudyTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="progressText" label="进度" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.progressText }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="studyStatusName"
          label="学习状态"
          align="center"
        />
        <el-table-column fixed="right" label="动作" align="center">
          <template slot-scope="scope">
            <el-button @click="goDetail(scope.row)" type="text" size="small">
              继续学习
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      :hide-on-single-page="true"
      style="text-align: center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate } from "@/utils/formatTime.js";
import navBack from "../../components/navBack.vue";
import { getStudyRecordPage } from "../../api/moudles/user.js";
import { getIntegralUrl } from "@/api/moudles/home.js";

export default {
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
      toPath: "videoplay",
    };
  },
  components: {
    navBack,
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
  }),
  created() {
    this.getChangeRecord();
  },
  methods: {
    formatDate,
    handleSizeChange(val) {
      this.pageSize = val;
      this.getChangeRecord();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getChangeRecord();
    },
    async goDetail(item) {
      localStorage.setItem("videoPlay", true);

      if (item.points == 0) {
        // 是否会员
        if (item.isVip === 1) {
          const dateNow = new Date().getTime();
          const effectiveDateTo = new Date(
            this.userInfo.effectiveDateTo
          ).getTime();

          if (dateNow > effectiveDateTo) {
            this.$message("会员已过期！");
          } else {
            // 登不登录都能看,有时间限制
            this.$router.push({
              name: this.toPath,
              params: {
                video_id: item.id,
                freeTime: item.freeTime,
                isVip: true,
              },
            });
          }
        } else {
          // // 免费
          this.$router.push({
            name: this.toPath,
            params: {
              video_id: item.id,
              isVip: false,
            },
          });
        }
      } else {
        // 扣几分查看视频
        this.getIntergarUrl(item);
      }
    },

    async getIntergarUrl(item) {
      await getIntegralUrl({
        data: {
          type: "video",
          id: item.id,
        },
        success: (res) => {
          console.log("res", res);
          if (res.data) {
            if (item.isVip === 1) {
              // 登不登录都能看,有时间限制
              this.$router.push({
                name: this.toPath,
                params: {
                  video_id: item.id,
                  freeTime: item.freeTime,
                  isVip: true,
                },
              });
            } else {
              // // 免费
              this.$router.push({
                name: this.toPath,
                params: {
                  video_id: item.id,
                  isVip: false,
                },
              });
            }
          } else {
            this.$message(res.msg);
          }
        },
      });
    },
    async getChangeRecord() {
      await getStudyRecordPage({
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        },
        success: (res) => {
          console.log("获取学习记录", res);
          this.tableData = res.data.list.map((item) => {
            return {
              ...item,
              id: item.videoId,
            };
          });
          this.totalNum = parseInt(res.data.total);
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .passwordetail_title {
    display: none;
  }
  .passwordetail {
    min-height: 700px;
    background-color: #fff;
    padding-bottom: 60px;
  }
}
@media screen and (min-width: 750px) {
  .passwordetail_title {
    height: 60px;
    font-weight: 500;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .passwordetail {
    min-height: 650px;
    background-color: #fff;
    padding-bottom: 20px;
  }
}
</style>
